module.exports = __webpack_public_path__ + "img/pleonomus-canaliculatus.1aff7f28.jpg";